import {resetPasswordTypes} from "./AuthActionsTypes/ResetPasswordActionsTypes";
import {removeUserResetPasswordErrors, setUserResetPasswordError} from "./AuthErrorsActions";
import axios from "axios";

export const requestUserResetPassword = () => {
    return {
        type: resetPasswordTypes.RESET_PASSWORD_REQUEST,
    };
};

export const successUserResetPassword = (data) => {
    return {
        type: resetPasswordTypes.RESET_PASSWORD_SUCCESS,
        accessToken: data.accessToken,
        verified: data.verified,
    };
};

export const failureUserResetPassword = (data) => {
    return {
        type: resetPasswordTypes.RESET_PASSWORD_FAILURE,
    };
};

export const userResetPassword = (user) => {
    return (dispatch, getState) => {
        dispatch(removeUserResetPasswordErrors());
        dispatch(requestUserResetPassword());

        const USER_RESET_PASSWORD_API = "https://api.scoutafrique.com/api/auth/reset";

        return axios.post(USER_RESET_PASSWORD_API, user).then(response => {
            const data = response.data;
            dispatch(successUserResetPassword(data));

        }).catch(error => {

            dispatch(failureUserResetPassword());
            dispatch(setUserResetPasswordError(error));

            return Promise.reject(error);
        });
    };
};
